import UpdatePasswordCardContainer from './UpdatePasswordCardContainer';

export default UpdatePasswordCardContainer;
